import Icon from '@/components/ui/AppIcon';

interface Contact {
  id: string;
  name: string;
  relationship: string;
  phone: string;
  email: string;
}

interface EmergencyContactsProps {
  contacts: Contact[];
}

export default function EmergencyContacts({ contacts }: EmergencyContactsProps) {
  return (
    <div className="bg-card rounded-xl shadow-brand p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-error/10 rounded-lg flex items-center justify-center">
            <Icon name="PhoneIcon" size={20} className="text-error" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground">
              Emergency Contacts
            </h3>
            <p className="text-sm text-muted-foreground">
              24/7 support available
            </p>
          </div>
        </div>
        <button className="text-sm font-medium text-primary hover:text-secondary transition-colors duration-300">
          Add Contact
        </button>
      </div>

      <div className="space-y-4">
        {contacts.map((contact) => (
          <div
            key={contact.id}
            className="p-4 bg-surface rounded-lg hover:bg-muted transition-colors duration-200"
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="font-heading font-semibold text-foreground">
                  {contact.name}
                </p>
                <p className="text-sm text-muted-foreground">{contact.relationship}</p>
              </div>
              <button className="p-2 hover:bg-background rounded-lg transition-colors duration-200">
                <Icon name="PencilIcon" size={16} className="text-muted-foreground" />
              </button>
            </div>

            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm">
                <Icon name="PhoneIcon" size={16} className="text-muted-foreground" />
                <span className="text-foreground">{contact.phone}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <Icon name="EnvelopeIcon" size={16} className="text-muted-foreground" />
                <span className="text-foreground">{contact.email}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-error/5 border border-error/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="ExclamationTriangleIcon" size={20} className="text-error flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-foreground mb-1">Emergency Assistance</p>
            <p className="text-sm text-muted-foreground mb-2">
              24/7 hotline: <span className="font-mono font-semibold text-error">+1-800-TRAVEL-911</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Available in 150+ countries with multilingual support
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}